var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-welcome-backdrop",
          class: { "wkb-welcome-backdrop--companion": _vm.showLearnCompanion },
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-welcome-shell",
              class: { "wkb-welcome-shell--companion": _vm.showLearnCompanion },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "wkb-welcome-modal",
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "wkb-welcome-title",
                  },
                },
                [
                  _vm.dismissible
                    ? _c(
                        "button",
                        {
                          staticClass: "wkb-welcome-close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                          },
                        },
                        [_vm._v(" × ")]
                      )
                    : _vm._e(),
                  _c("header", { staticClass: "wkb-welcome-head" }, [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "wkb-welcome-tabs",
                        attrs: {
                          role: "tablist",
                          "aria-label": "Welcome sections",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "wkb-welcome-tab",
                            class: { "is-active": _vm.activeTab === "start" },
                            attrs: {
                              id: "wkb-welcome-tab-start",
                              type: "button",
                              role: "tab",
                              "aria-selected":
                                _vm.activeTab === "start" ? "true" : "false",
                              "aria-controls": "wkb-welcome-panel-start",
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "start"
                              },
                            },
                          },
                          [_vm._v(" Start Canvas ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "wkb-welcome-tab",
                            class: { "is-active": _vm.activeTab === "learn" },
                            attrs: {
                              id: "wkb-welcome-tab-learn",
                              type: "button",
                              role: "tab",
                              "aria-selected":
                                _vm.activeTab === "learn" ? "true" : "false",
                              "aria-controls": "wkb-welcome-panel-learn",
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "learn"
                              },
                            },
                          },
                          [_vm._v(" Learn Canvas ")]
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "start",
                          expression: "activeTab === 'start'",
                        },
                      ],
                      staticClass: "wkb-welcome-panel",
                      attrs: {
                        id: "wkb-welcome-panel-start",
                        role: "tabpanel",
                        "aria-labelledby": "wkb-welcome-tab-start",
                      },
                    },
                    [
                      _vm._m(1),
                      _c("div", { staticClass: "wkb-welcome-options" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "wkb-welcome-option wkb-welcome-option-primary",
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "wkb-welcome-option-title" },
                              [_vm._v("Create a new graph")]
                            ),
                            _c(
                              "div",
                              { staticClass: "wkb-welcome-create-path" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "wkb-welcome-create-path-desc",
                                  },
                                  [
                                    _vm._v(
                                      " Find genes, gene sets, mechanisms, and traits one at a time and choose what to start with. "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wkb-welcome-action wkb-welcome-action-primary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("create")
                                      },
                                    },
                                  },
                                  [_vm._v(" Search catalog ")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "wkb-welcome-create-path" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "wkb-welcome-create-path-desc",
                                  },
                                  [
                                    _vm._v(
                                      " Tell the AI assistant what you want to explore; it finds relevant nodes and adds them to your graph. "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "wkb-welcome-action wkb-welcome-action-primary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "create-with-assistant"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" Describe with AI ")]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "wkb-welcome-option" }, [
                          _c(
                            "span",
                            { staticClass: "wkb-welcome-option-title" },
                            [_vm._v("Open from My library")]
                          ),
                          _c(
                            "span",
                            { staticClass: "wkb-welcome-option-desc" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.hasSavedGraphs
                                      ? "Open graphs saved in this browser (layout only, no inspector data)."
                                      : "No saved graphs in this browser yet. Open My library to restore a backup from another machine."
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "wkb-welcome-action",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("load-library")
                                },
                              },
                            },
                            [_vm._v(" Open My library ")]
                          ),
                        ]),
                        _c("div", { staticClass: "wkb-welcome-option" }, [
                          _c(
                            "span",
                            { staticClass: "wkb-welcome-option-title" },
                            [_vm._v("Import graph")]
                          ),
                          _vm._m(2),
                          _c(
                            "button",
                            {
                              staticClass: "wkb-welcome-action",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("import-graph")
                                },
                              },
                            },
                            [_vm._v(" Import graph ")]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "learn",
                          expression: "activeTab === 'learn'",
                        },
                      ],
                      staticClass: "wkb-welcome-panel",
                      attrs: {
                        id: "wkb-welcome-panel-learn",
                        role: "tabpanel",
                        "aria-labelledby": "wkb-welcome-tab-learn",
                      },
                    },
                    [
                      _c("WorkspaceLearnCanvasPanel", {
                        attrs: { variant: "tab" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm.showLearnCompanion
                ? _c("WorkspaceLearnCanvasPanel", {
                    attrs: {
                      variant: "companion",
                      "canvas-open-count": _vm.canvasOpenCount,
                      "learn-companion-max-opens": _vm.learnCompanionMaxOpens,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h2",
      { staticClass: "wkb-welcome-title", attrs: { id: "wkb-welcome-title" } },
      [
        _vm._v(" Welcome to "),
        _c("span", { staticClass: "wkb-welcome-brand" }, [
          _c("span", { staticClass: "wkb-welcome-mark" }, [_vm._v("REVEAL")]),
          _c("span", { staticClass: "wkb-welcome-name" }, [
            _vm._v("KG Canvas"),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-welcome-intro" }, [
      _vm._v(" Start a new graph, open one from "),
      _c("strong", [_vm._v("My library")]),
      _vm._v(", or import a graph file you exported earlier. "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "wkb-welcome-option-desc" }, [
      _vm._v(" Load a JSON workflow file exported from "),
      _c("strong", [_vm._v("Manage → Export graph")]),
      _vm._v(", including inspector data. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }